<template>
  <b-modal
    id="cambiarAvlForm"
    title="CAMBIAR AVL"
    size="lg"
    hide-footer
    no-close-on-esc
    @shown="onModalShown"
  >
    <div class="card">
      <div class="card-body">
        <div class="container-fluid h-100">
          <div class="row h-100">
            <form
              @submit.prevent="submit"
              v-promise-btn="{ action: 'submit' }"
              ref="form"
            >
              <div class="container">
                <div class="row">
                  <div class="col-12 col-md-6 form-group form-group-md">
                    <div class="form-group">
                      <label for="idCliente" class="label"
                        >Nombre del cliente</label
                      >
                      <input
                        type="text"
                        class="form-control text-center bg-white"
                        disabled
                        name="idCliente"
                        id="idCliente"
                        style="cursor: text"
                        v-model="nombreCliente"
                      />
                    </div>
                  </div>

                  <div class="col-12 col-md-6 form-group form-group-md">
                    <div class="form-group">
                      <label for="avlAnterior" class="label"
                        >avl anterior</label
                      >
                      <input
                        id="avlAnterior"
                        v-model="avlAnterior"
                        class="form-control text-center bg-white"
                        disabled
                        style="cursor: text"
                        type="text"
                      />
                    </div>
                  </div>
                  <div class="col-12 form-group form-group-sm">
                    <label class="label" for="instalador">Instalador</label>
                    <SelectInstalador v-model="instalador" />
                  </div>
                  <div :class="`col-12 form-group form-group-sm`">
                    <label class="label" for="avlChip">AVL Chip</label>
                    <SelectAvlChip v-model="avlNuevo" />
                  </div>
                  <div class="col-12 form-group form-group-md">
                    <div class="form-group">
                      <label for="chip_nuevo" class="label"
                        >Ubicacion de avl</label
                      >
                      <input
                        type="text"
                        class="form-control text-center"
                        name="chip nuevo"
                        id="chip_nuevo"
                        v-model="ubicacionAvl"
                      />
                    </div>
                  </div>

                  <div class="col-12 form-group form-group-md">
                    <div class="form-group">
                      <label for="comentario_trazabilidad" class="label"
                        >Comentario de trazabilidad</label
                      >
                      <textarea
                        type="text"
                        class="form-control"
                        name="comentario de trazabilidad"
                        id="comentario_trazabilidad"
                        v-model="comentarioTrazabilidad"
                      />
                    </div>
                  </div>
                  <div class="col-12 col-md-6 form-group form-group-md">
                    <div class="form-group">
                      <label for="costoCambioAVL" class="label"
                        >Costo por el cambio</label
                      >
                      <input
                        type="text"
                        v-select-on-focus
                        class="form-control"
                        name="costo cambio Avl"
                        id="costoCambioAVL"
                        v-model="costoServicio"
                      />
                    </div>
                  </div>
                  <div class="col-12 col-md-6 form-group form-group-md">
                    <label
                      class="form-check-label"
                      for="porCambioDeVehiculo"
                      style="cursor: pointer"
                    >
                      Cambio por vehículo
                    </label>
                    <input
                      id="porCambioDeVehiculo"
                      v-model="porCambioDeVehiculo"
                      class="form-check"
                      style="zoom: 1.2; cursor: pointer"
                      type="checkbox"
                    />
                  </div>
                  <div class="col-12 col-md-6 form-group form-group-md">
                    <label
                      class="form-check-label"
                      for="avlRoto"
                      style="cursor: pointer"
                    >
                      AVL roto
                    </label>
                    <input
                      id="avlRoto"
                      v-model="avlRoto"
                      class="form-check"
                      style="zoom: 1.2; cursor: pointer"
                      type="checkbox"
                    />
                  </div>
                  <div class="col-12 col-md-6 form-group form-group-md">
                    <label
                      class="form-check-label"
                      for="aditivo"
                      style="cursor: pointer"
                    >
                      Aditivo
                    </label>
                    <input
                      id="aditivo"
                      v-model="aditivo"
                      class="form-check"
                      style="zoom: 1.2; cursor: pointer"
                      type="checkbox"
                    />
                  </div>
                  <div class="col-12 col-md-6 form-group form-group-md">
                    <label
                      class="form-check-label"
                      for="avlExtraviado"
                      style="cursor: pointer"
                    >
                      AVL extraviado
                    </label>
                    <input
                      id="avlExtraviado"
                      v-model="avlExtraviado"
                      class="form-check"
                      style="zoom: 1.2; cursor: pointer"
                      type="checkbox"
                    />
                  </div>
                  <div class="col-12 col-md-6 form-group form-group-md">
                    <label
                      class="form-check-label"
                      for="instalacionEnTaller"
                      style="cursor: pointer"
                    >
                      Instalación en taller
                    </label>
                    <input
                      id="instalacionEnTaller"
                      v-model="taller"
                      class="form-check"
                      style="zoom: 1.2; cursor: pointer"
                      type="checkbox"
                    />
                  </div>
                  <ViaticosForm v-model="viaticos" ref="viaticosForm" />
                </div>
              </div>
              <div class="w-100 d-flex justify-content-end">
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="$bvModal.hide('cambiarAvlForm')"
                >
                  Cancelar
                </button>
                <button type="submit" class="btn btn-primary">Guardar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { get } from "lodash-es";
import NombreCliente from "../../../shared/NombreCliente";
import SelectAvlChip from "../../Commons/SelectAvlChip.vue";
import SelectInstalador from "../../Commons/SelectInstalador.vue";
import axios from "axios";
import ViaticosForm from "../../../../../components/Viaticos/ViaticosForm.vue";

export default {
  name: "cambiar-avl",

  mounted() {
    this.getNombreCliente(this.$route.params.id_cliente);
  },
  data: () => ({
    instalador: null,
    avlNuevo: null,
    comentarioTrazabilidad: "",
    costoServicio: 0,
    porCambioDeVehiculo: false,
    avlRoto: false,
    aditivo: false,
    avlExtraviado: false,
    taller: false,
    ubicacionAvl: "",
    viaticos: {
      viaticosCliente: {
        activo: false,
        combustible: {
          activo: false,
          kilometros: 0,
          montoCalculado: 0,
          desgloseCalculo: "",
          descripcion: "",
        },
        viaticoAdicional: { activo: false, monto: 0, descripcion: "" },
      },
      viaticosInstalador: {
        activo: false,
        combustible: {
          activo: false,
          kilometros: 0,
          montoCalculado: 0,
          desgloseCalculo: "",
          descripcion: "",
        },
        viaticoAdicional: { activo: false, monto: 0, descripcion: "" },
      },
    },
  }),
  mixins: [NombreCliente],
  components: {
    SelectInstalador,
    SelectAvlChip,
    ViaticosForm,
  },
  methods: {
    onModalShown() {
      this.instalarOtroDia = false;
      this.instalador = null;
      this.avlNuevo = null;
      this.ubicacionAvl = this.UbicacionAvl;
      this.comentarioTrazabilidad = "";
      this.costoServicio = 0;
      this.porCambioDeVehiculo = false;
      this.avlRoto = false;
      this.aditivo = false;
      this.avlExtraviado = false;
      this.taller = false;
      this.viaticos = {
        viaticosCliente: {
          activo: false,
          combustible: {
            activo: false,
            kilometros: 0,
            montoCalculado: 0,
            desgloseCalculo: "",
            descripcion: "",
          },
          viaticoAdicional: { activo: false, monto: 0, descripcion: "" },
        },
        viaticosInstalador: {
          activo: false,
          combustible: {
            activo: false,
            kilometros: 0,
            montoCalculado: 0,
            desgloseCalculo: "",
            descripcion: "",
          },
          viaticoAdicional: { activo: false, monto: 0, descripcion: "" },
        },
      };
    },
    async submit() {
      if (this.instalador === null) {
        this.$msgBoxOk("Por favor, seleccione un instalador");
        return;
      }
      if (this.avlNuevo === null) {
        this.$msgBoxOk("Por favor, seleccione un nuevo avl");
        return;
      }
      if (this.ubicacionAvl.trim() === "") {
        this.$msgBoxOk("Por favor, complete el campo ubicacion de avl");
        return;
      }
      if (this.comentarioTrazabilidad.trim() === "") {
        this.$msgBoxOk("Por favor, complete el campo de trazabilidad");
        return;
      }

      if (this.$refs.viaticosForm) {
        const viaticosErrors = this.$refs.viaticosForm.validateForm();
        if (viaticosErrors.length > 0) {
          const mensaje = viaticosErrors.map((msj) =>
            this.$createElement("p", msj),
          );
          this.$msgBoxOk(mensaje, {
            title: this.$createElement("h4", "Controlar formulario"),
          });
          return;
        }
      }

      const viaticosFormateados = this.$refs.viaticosForm
        ? this.$refs.viaticosForm.getFormattedViaticos()
        : this.viaticos;

      const resp = await axios.post("/execute", {
        method: "CLI.CambiarAvl",
        parameters: [
          {
            name: "id_cliente_del_AVL_a_cambiar",
            value: this.$route.params.id_cliente,
          },
          { name: "id_avl_ant", value: this.avlAnterior },
          { name: "id_instalador", value: this.instalador.id_instaladores },
          { name: "id_avl_nuevo", value: this.avlNuevo.id_avl },
          { name: "ubicacion_avl", value: this.ubicacionAvl },
          {
            name: "comentario_trazabilidad",
            value: this.comentarioTrazabilidad,
          },
          { name: "costo_cliente", value: this.costoServicio },
          {
            name: "por_cambio_de_vehiculo",
            value: this.porCambioDeVehiculo ? 1 : 0,
          },
          { name: "avl_roto", value: this.avlRoto ? 1 : 0 },
          { name: "taller", value: this.taller ? 1 : 0 },
          { name: "aditivo", value: this.aditivo ? 1 : 0 },
          { name: "avl_EXTRAVIADO", value: this.avlExtraviado ? 1 : 0 },
          {
            name: "viaticos_cliente_activo",
            value: viaticosFormateados.viaticosCliente.activo ? 1 : 0,
          },
          {
            name: "viaticos_cliente_combustible_activo",
            value: viaticosFormateados.viaticosCliente.combustible.activo
              ? 1
              : 0,
          },
          {
            name: "viaticos_cliente_combustible_kilometros",
            value: viaticosFormateados.viaticosCliente.combustible.kilometros,
          },
          {
            name: "viaticos_cliente_combustible_monto_calculado",
            value:
              viaticosFormateados.viaticosCliente.combustible.montoCalculado,
          },
          {
            name: "viaticos_cliente_combustible_descripcion",
            value: viaticosFormateados.viaticosCliente.combustible.descripcion,
          },
          {
            name: "viaticos_cliente_adicional_activo",
            value: viaticosFormateados.viaticosCliente.viaticoAdicional.activo
              ? 1
              : 0,
          },
          {
            name: "viaticos_cliente_adicional_monto",
            value: viaticosFormateados.viaticosCliente.viaticoAdicional.monto,
          },
          {
            name: "viaticos_cliente_adicional_descripcion",
            value:
              viaticosFormateados.viaticosCliente.viaticoAdicional.descripcion,
          },
          {
            name: "viaticos_instalador_activo",
            value: viaticosFormateados.viaticosInstalador.activo ? 1 : 0,
          },
          {
            name: "viaticos_instalador_combustible_activo",
            value: viaticosFormateados.viaticosInstalador.combustible.activo
              ? 1
              : 0,
          },
          {
            name: "viaticos_instalador_combustible_kilometros",
            value:
              viaticosFormateados.viaticosInstalador.combustible.kilometros,
          },
          {
            name: "viaticos_instalador_combustible_monto_calculado",
            value:
              viaticosFormateados.viaticosInstalador.combustible.montoCalculado,
          },
          {
            name: "viaticos_instalador_combustible_descripcion",
            value:
              viaticosFormateados.viaticosInstalador.combustible.descripcion,
          },
          {
            name: "viaticos_instalador_adicional_activo",
            value: viaticosFormateados.viaticosInstalador.viaticoAdicional
              .activo
              ? 1
              : 0,
          },
          {
            name: "viaticos_instalador_adicional_monto",
            value:
              viaticosFormateados.viaticosInstalador.viaticoAdicional.monto,
          },
          {
            name: "viaticos_instalador_adicional_descripcion",
            value:
              viaticosFormateados.viaticosInstalador.viaticoAdicional
                .descripcion,
          },
        ],
      });

      if (resp.data.ok) {
        this.$msgBoxOk("Cambio de avl realizado con éxito").then(() => {
          if (this.avlExtraviado) {
            this.$msgBoxOk(
              "Recordar dar de baja el chip AVL y generar en administración la gestión de recupero .",
            );
          }
        });
        this.$emit("update");
        this.$bvModal.hide("cambiarAvlForm");
      } else {
        this.$msgBoxOk(
          get(
            resp,
            "data.message",
            "Ha ocurrido un  error, no se pudo cambiar avl",
          ),
        );
      }
    },
  },
  computed: {
    avlAnterior: {
      get() {
        return this.$store.state.Contratos.ModificarContrato.avl;
      },
    },
    idCliente: {
      get() {
        return this.$route.params.id_cliente;
      },
    },
    UbicacionAvl: {
      get() {
        return this.$store.state.Contratos.ModificarContrato.ubicacionAvl;
      },
      set(value) {
        this.$store.commit(
          "Contratos/ModificarContrato/setUbicacionAvl",
          value,
        );
      },
    },
  },
};
</script>
<style></style>
